import React from 'react';
import axios from 'axios';
import InputMask from 'react-input-mask';

import Loading from '../Loading';

import InputDebtorSelector from '../InputSpecialFields/InputDebtorSelector';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';
import { ReactComponent as PlusIcon } from '../../icons/plus.svg';

export default function AddNewdebtorNameToCase({ caseId, formInfo, setFormInfo, access, userId, onSuccess }) {
    const [isPanelOpen, setIsPanelOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [status, setStatus] = React.useState('');

    React.useEffect(() => {
        if (!formInfo.debtor_id && formInfo.debtor_name) {
            setFormInfo((prev) => ({
                ...prev,
                debtor_type: 'Физическое лицо',
            }))
        }
    }, [formInfo.debtor_id, formInfo.debtor_name])

    const [errorsForm, setErrorsForm] = React.useState({

    });

    const attachNewdebtorName = () => {
        const token = localStorage.getItem('token');

        setLoading(true);

        axios.post('/api/add-new-case-debtor',
            {
                case_id: caseId,
                debtor_id: formInfo.debtor_id,
                debtor_type: formInfo.debtor_type,
                debtor_name: formInfo.debtor_name,
                debtor_postal_address: formInfo.debtor_address,
                debtor_tin: formInfo.debtor_tin,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ).then(() => {
            onSuccess();
            setIsPanelOpen(false);
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>{error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        isPanelOpen ? 
            <div className='panel'>
                <div className='panelHeader'>
                    <h3>Добавление должника к карточке</h3>
                    <IconContainer 
                        Icon={XIcon} 
                        onClick={() => {
                            setIsPanelOpen(false);
                        }} 
                        size = '17' 
                        color = 'black' 
                        className = '' 
                    />
                </div>
                <div className='panelMain'>
                    <div className='labelInputRight'>
                        <div className='inputWrapper'>
                            <InputDebtorSelector
                                initialSearchTerm={formInfo.debtor_name}
                                formInfo={formInfo}
                                setFormInfo={setFormInfo}
                                errorsForm={errorsForm}
                                setErrorsForm={setErrorsForm}
                                isAddNew={true}
                                entity_type={formInfo.debtor_type}
                            />
                        </div>
                    </div>
                    {(!formInfo.debtor_id && formInfo.debtor_name) &&
                    <>
                    <div className='radioSwitchWrapper'>
                        <label className={`radioSwitchLabel ${formInfo.debtor_type === 'Физическое лицо' ? 'selected' : ''}`}>
                            <input
                                type='radio'
                                name='typeSelector'
                                value='Физическое лицо'
                                checked={formInfo.debtor_type === 'Физическое лицо'}
                                onChange={(e) => setFormInfo((prev) => ({
                                    ...prev,
                                    debtor_type: e.target.value,
                                }))}
                            />
                            <span>Физическое лицо</span>
                        </label>
                        <label className={`radioSwitchLabel ${formInfo.debtor_type === 'Юридическое лицо' ? 'selected' : ''}`}>
                            <input
                                type='radio'
                                name='typeSelector'
                                value='Юридическое лицо'
                                checked={formInfo.debtor_type === 'Юридическое лицо'}
                                onChange={(e) => setFormInfo((prev) => ({
                                    ...prev,
                                    debtor_type: e.target.value,
                                }))}
                            />
                            <span>Юридическое лицо</span>
                        </label>
                    </div>
                    <input 
                        type='text' 
                        value={formInfo.postal_address} 
                        onChange={(e) => setFormInfo((prev) => ({
                            ...prev,
                            postal_address: e.target.value,
                        }))}
                        // className={errorsForm.internal_number ? 'inputError' : ''}
                        placeholder='Адрес должника' 
                        minLength='' 
                        maxLength='150' 
                        required 
                    />
                    <div className='inputWrapper'>
                        <InputMask
                            mask="999999999999"
                            value={formInfo.debtor_tin}
                            onChange={(e) => setFormInfo((prev) => ({
                                ...prev,
                                debtor_tin: e.target.value,
                            }))}
                            maskChar={null}
                        >
                        {(inputProps) => (
                            <input
                            {...inputProps}
                            type='text'
                            placeholder='ИНН'
                            />
                        )}
                        </InputMask>
                    </div>
                    </>}
                </div>
                <div className='panelBottom'>
                    <div>{status}</div>
                    {loading ? 
                        <Loading type='inline' />
                    :
                        <button 
                        type='button' 
                        className='button' 
                        onClick={attachNewdebtorName}
                        disabled={loading}
                        >
                            Добавить
                        </button>
                    }
                </div>
            </div>
        :   <button 
                type='button' 
                className='button miniButton' 
                onClick={() => {setIsPanelOpen(true)}}
            >
                <PlusIcon />
                Добавить должника
            </button>
    )
}
